import { SellerGroupDTO } from './seller_group';

export enum UserType {
  ROOT = 'ROOT',
  COMMON = 'COMMON',
}

export enum UserRole {
  ROOT = 'ROOT',
  ADMIN = 'ADMIN',
  COPRODUCER = 'COPRODUCER',
  EDITOR = 'EDITOR',
  SCANNER = 'SCANNER',
  SELLER = 'SELLER',
  USER = 'USER',
  CASHIER = 'CASHIER',
}

export const userPermissionsArray: UserRole[] = [
  UserRole.ADMIN,
  UserRole.COPRODUCER,
  UserRole.EDITOR,
  UserRole.SCANNER,
  UserRole.SELLER,
  UserRole.USER,
  UserRole.CASHIER,
];

export const displayUserPermissions = {
  ADMIN: 'Administrador',
  COPRODUCER: 'Coproductor',
  EDITOR: 'Editor',
  SCANNER: 'Escaner',
  SELLER: 'Vendedor',
  USER: 'Usuario',
  CASHIER: 'Cajero',
};

export interface UserBusiness {
  id: string;
  business_id: string;
  user_id: string;
  active: boolean;
  permissions: UserRole;
  notification_emails_enabled: boolean;
}

export type UpdateBusinessUserPermissionsDTO = {
  id: string;
  active?: boolean;
  permissions?: UserRole;
  notification_emails_enabled?: boolean;
};

export interface UserEvent {
  id: string;
  event_id: string;
  user_id: string;
  active: boolean;
  permissions: UserRole;
  seller_comission_rate: number;
  qr_count: number;
  qr_active: boolean;
  referral_id: string;
  user: UserDTO;
  alias: string;
  tag: string;
  seller_group_id: string;
  seller_group?: SellerGroupDTO;
  scanner_type_id?: string | null;
}

export interface AuthUserData {
  id: string;
  username: string,
  type: UserType,
  email: string,
  phone_number: string,
  user_businesses: UserBusiness[]
  user_events: UserEvent[]
  photo_url: string
}
export default interface UserDTO {
  id: string;
  email: string;
  username: string;
  phone_number: string;
  firebaseId: string;
  type: UserType;
  is_verified: boolean;
  verification_code: string;
  user_businesses: UserBusiness[];
  user_events: UserEvent[];
  photo_url: string;
}

export type UserWithBusiness = UserDTO & { user_business: UserBusiness };
export type UserWithBusinessAndEvent = UserDTO & { user_business: UserBusiness, user_event: UserEvent };
